import { useNavigate } from "react-router-dom";
import { BookLabProjectWorkspace } from "../../BookLabProject";
import { useBookEditor } from "../BookEditorProvider";

/**
 * Write mode — reuses the structured Book Lab writer (Turn 1).
 * Shared bookId / chapter selection syncs through BookEditorProvider.
 */
export default function WriteMode() {
  const nav = useNavigate();
  const {
    bookId,
    activeChapterId,
    setActiveChapterId,
    setMode,
    selectBlock,
  } = useBookEditor();

  return (
    <div className="book-editor-write-mode" data-testid="book-editor-write-mode">
      <BookLabProjectWorkspace
        bookId={bookId}
        nav={nav}
        embedded
        initialChapterId={activeChapterId}
        onChapterChange={setActiveChapterId}
        onBlockSelect={(id) => selectBlock(id)}
        onRequestCanvas={() => setMode("canvas")}
      />
    </div>
  );
}
